export default __webpack_public_path__ + "static/media/logo.c32664e4.png";